var map = {
	"./banner.png": 22313,
	"./en.png": 17042,
	"./english.png": 12451,
	"./largebanner/banner-1.png": 11989,
	"./largebanner/banner-2.png": 9886,
	"./largebanner/banner-3.png": 97575,
	"./logo.png": 82806,
	"./marker.png": 62333,
	"./mm.png": 44225,
	"./myanmar.png": 59458,
	"./pdf_logo.png": 93223,
	"./placeholder.png": 16628,
	"./profile.png": 45572,
	"./profile_medium.png": 2300,
	"./smallbanner/banner-1.png": 25389,
	"./smallbanner/banner-2.png": 18358,
	"./smallbanner/banner-3.png": 96447,
	"./smilegirl.png": 21681,
	"./sypitarn_mascot.png": 69369,
	"./th.png": 41855,
	"./thailand.png": 17474,
	"./whatwedo.png": 48114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;